function u(t) {
  return !!(t.stockProductId && t.count <= 0);
}
export {
  u as default
};
